import React from "react"
import BigCalendar from "react-big-calendar"
import moment from "moment"
import MonthEvent from "./MonthEvent"
import { IJobDocument, IJobInfo } from "../../../models"
import * as timeHelper from "../../../helpers/timeHelper"
import * as utils from "../../../helpers/utils"
import "react-big-calendar/lib/css/react-big-calendar.css"
import "./styles.css"
export interface IBigCalendarEvent {
  start: Date
  end: Date
  jobName: string
  jobId: string
  elId: string
  jobInfo: IJobInfo
  setJobInfo: (info: IJobInfo) => void
  previouslyFetchedJobId: string
  setPreviouslyFetchedJobId: (id: string) => void
}

interface IProps {
  jobs: IJobDocument[]
  refereceDate: Date
}

interface IState {
  jobInfo: IJobInfo
  previouslyFetchedJobId: string,
  events: IBigCalendarEvent[]
}

export default class ClientJobCalendarView extends React.Component<IProps, IState> {

  constructor(props) {
    super(props)
    this.state = {
      jobInfo: undefined,
      previouslyFetchedJobId: undefined,
      events: []
    }
  }

  componentDidMount() {
    const events = []
    const monthStartDate = moment(this.props.refereceDate).startOf("month").format()
    const monthEndDate = moment(this.props.refereceDate).endOf("month").format()
    this.props.jobs.forEach(job => {
      let date = timeHelper.keepConvertUTCToLocal(job.StartDate)
      if (moment(date).isSameOrAfter(monthStartDate) && moment(date).isBefore(monthEndDate)) {
        events.push({
          start: moment(date).toDate(),
          end: moment(date).toDate(),
          jobName: job.Name,
          jobId: job.Id,
          elId: utils.guid(),
          jobInfo: this.state.jobInfo,
          setJobInfo: (jobInfo) => this.setState({ jobInfo }),
          previouslyFetchedJobId: this.state.previouslyFetchedJobId,
          setPreviouslyFetchedJobId: (previouslyFetchedJobId) => this.setState({ previouslyFetchedJobId }),
        })
      }
    })
    this.setState({ events })
  }

  render() {
    return (
      <div>
        <BigCalendar
          popup
          views={{ month: true, week: false }}
          defaultView={BigCalendar.Views.MONTH}
          step={60}
          className={"Job-container"}
          localizer={BigCalendar.momentLocalizer(moment)}
          events={this.state.events}
          defaultDate={this.props.refereceDate}
          eventPropGetter={() => ({ className: "Job-Event-Node" })}
          toolbar={false}
          components={{
            month: { event: MonthEvent }
          }}
        />
      </div>
    )
  }
}
